module.exports = __webpack_public_path__ + "static/hoar-symbol-SCAG-bdef884e2c7a4ba9fbc7a37b7d8a34ba.png";